/* eslint-disable max-classes-per-file */
import React, { useEffect } from 'react';
import { getSingleFileItem as findFirstFileItem, itemContainsImage, } from 'app/utils/dnd';
import { call } from 'app/utils/function';
class UnsupportedClipboardSizeError extends Error {
    constructor() {
        super('Unsupported clipboard size. Expected 1 item in clipboard');
    }
}
class UnsupportedClipboardFormatError extends Error {
    constructor(kind) {
        super('Unsupported clipboard format');
        Object.defineProperty(this, "kind", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: kind
        });
    }
    toString() {
        return `Error: ${this.message}; kind = ${this.kind}`;
    }
}
class ImageNotFoundInClipboardError extends Error {
    constructor() {
        super('Image not found in clipboard');
    }
}
class NotAcceptingFileTypeError extends Error {
    constructor(type) {
        super('Not accepted file type');
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: type
        });
    }
    toString() {
        return `Error: ${this.message}; type = ${this.type}`;
    }
}
class FileSizeExceededLimitError extends Error {
    constructor(size, maxSize) {
        super('File size exceeded limit');
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: size
        });
        Object.defineProperty(this, "maxSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: maxSize
        });
    }
    toString() {
        return `Error: ${this.message}; size = ${this.size}; maxSize = ${this.maxSize}`;
    }
}
class FileNotAvailableError extends Error {
    constructor() {
        super('File object not available');
    }
}
export const useFilePaste = (opts) => {
    const { accept = null, maxSize = 1e6, onError } = opts;
    const [file, setFile] = React.useState(null);
    const onDocumentPaste = React.useCallback((event) => {
        const { clipboardData } = event;
        // ignore paste in html inputs
        if (event.target instanceof HTMLInputElement ||
            event.target instanceof HTMLTextAreaElement) {
            return;
        }
        const fileItem = findFirstFileItem(clipboardData);
        if (!fileItem) {
            call(onError, new UnsupportedClipboardSizeError());
            return;
        }
        if (fileItem.kind !== 'file') {
            call(onError, new UnsupportedClipboardFormatError(fileItem.kind));
        }
        if (!itemContainsImage(fileItem)) {
            call(onError, new ImageNotFoundInClipboardError());
            return;
        }
        if (accept && !accept.includes(fileItem.type)) {
            call(onError, new NotAcceptingFileTypeError(fileItem.type));
            return;
        }
        const pastedFile = fileItem.getAsFile();
        if (!pastedFile) {
            call(onError, new FileNotAvailableError());
            return;
        }
        if (pastedFile.size > maxSize) {
            call(onError, new FileSizeExceededLimitError(pastedFile.size, maxSize));
            return;
        }
        setFile(pastedFile);
    }, [accept, maxSize, setFile, onError]);
    useEffect(() => {
        document.addEventListener('paste', onDocumentPaste, false);
        return () => {
            document.removeEventListener('paste', onDocumentPaste, false);
        };
    }, [onDocumentPaste]);
    return [file];
};
